import {EntityType} from './document';

export interface Notification {
  id: number,
  isRead: boolean,
  subject: string,
  body: string,
  entityType: EntityType,
  entityId: number,
  userId: number,
  createdOn: string,
  modifiedOn: string,
  notificationType: 'Undefined' | 'MentionInChat' | 'MissingRequiredDocuments'|'DocumentsToValidate'
    |'DocumentRejected'|'ProjectDateChanged'|'ProjectAdjudicated'|'AssignedToProject'|'AskedForApproval',
  path?:any;
  data?: any; // Datos adicionales específicos del tipo de notificación
  user?: {
    id: number,
    email: string,
    roleId: number,
    role: any,
    partnerId: number,
    partner: {
      id: number,
      avatar?: string,
      name: string,
      surName?: string,
      phone?: string,
      email: string,
      position?: string,
      odooEntityId?: number
    }
  };

  oldDate?: string;
  newDate?: string;
  missingDocuments?: {docType: string, entityType: EntityType, entityId: number}[];
  project: {id: number, name: string},
  service?: {id: number, name: string},
  documents?: {id: number, name: string, type: string}[],
  partner?: {id: number, name: string, avatar: string},
  chatId?: number,
}
